const role = 'role'
export const readiness_zone = "readiness-zone"
export const readiness_zone_route = {
    readinessHome: `/${role}/${readiness_zone}/home/:type`,
    addReadiness: `/${role}/${readiness_zone}/add`,
    editReadiness: `/${role}/${readiness_zone}/edit/:readid`
}

export default readiness_zone_route